import { FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchSearchFn } from '@common/search.services';
import { useQuery } from '@tanstack/react-query';
import { isValidApiBaseProps } from '@common/api.services';
import { isPositiveNumber } from '@core/Primitives/number.services';
import {
  IProjectDrawingHistoryRequest,
  IProjectDrawingRegisterFilter,
  IProjectDrawingRegisterSearch,
  IProjectDrawingSearchFilter,
  IProjectMasterScheduleDrawingRegisterSearchResult,
} from './projectDrawingRegister.models';
import {
  getDrawingHistoriesAsync,
  searchDrawingRegisterAsync,
  searchDrawingsAsync,
} from './projectDrawingRegister.services';

export const useFetchDrawingSearch = createUseFetchSearchFn<IProjectDrawingSearchFilter, IProjectDrawingRegisterSearch>(
  {
    queryName: FETCH_QUERIES_NAME.DRAWING_SEARCH,
    searchAsyncFn: searchDrawingsAsync,
  },
);

export const useFetchDrawingRegister = createUseFetchSearchFn<
  IProjectDrawingRegisterFilter,
  IProjectMasterScheduleDrawingRegisterSearchResult
>({
  queryName: FETCH_QUERIES_NAME.DRAWING_REGISTER,
  searchAsyncFn: searchDrawingRegisterAsync,
});

export const useFetchDrawingHistories = (props: IProjectDrawingHistoryRequest, enabled = true) => {
  return useQuery(
    [props.projectId, props.projectMasterScheduleId, props.transmittalItemId, FETCH_QUERIES_NAME.DRAWING_HISTORIES],
    async () => {
      const results = await getDrawingHistoriesAsync(props);
      return results;
    },
    {
      enabled:
        isValidApiBaseProps(props) &&
        isPositiveNumber(props.projectMasterScheduleId) &&
        isPositiveNumber(props.transmittalItemId) &&
        enabled,
    },
  );
};
